const OptionHelper = {
	locationStatus() {
		return [{
			value: 'available',
			text: 'Available'
		}, {
			value: 'occupied',
			text: 'Occupied'
		},{
			value: 'under maintenance',
			text: 'Under Maintenance'
		}];
	},
	machineWorkingStatus() {
		return [
			{
				value: 'available',
				text: 'Available'
			}, {
				value: 'unavailable',
				text: 'Unavailable'
			}, {
				value: 'occupied',
				text: 'Occupied'
			}, {
				value: 'under_maintenance',
				text: 'Under Maintenance'
			}];
	},
	adminStatus() {
		return [
			{
				text: 'Enabled',
				value: 'enabled'
			},
			{
				text: 'Disabled',
				value: 'disabled'
			}
		];
	},
	equipmentStatus() {
		return [
			{
				text: 'Enabled',
				value: 'enabled'
			},
			{
				text: 'Disabled',
				value: 'disabled'
			}
		];
	},
	equipmentTypeOptions() {
		return [
			{
				value: 'online_booking_equipment',
				text: 'Online Booking Equipment'
			},
			{
				value: 'non_booking_equipment',
				text: 'Non-Booking Equipment'
			}
		];
	}
};


export default OptionHelper;
